import ExportType from "@/apps/dashboard/buybackDiagnostic/core/domain/ExportType.enum";
import {
  getDiagnosticCsvExport,
  startDiagnosticExport,
} from "@/apps/dashboard/buybackDiagnostic/core/infrastructure/repository/exportRepository";
import { ExportCsv } from "@/apps/dashboard/buybackDiagnostic/core/domain/ExportCsv";

export const startExport = (value: ExportType, organizationId: string): Promise<ExportCsv> => {
  switch (value) {
    case ExportType.DIAGNOSTIC:
      return startDiagnosticExport(organizationId);
    default:
      return Promise.reject("Invalid diagnostic export type");
  }
};

export const getExportCsv = (exportCsv: ExportCsv): Promise<ExportCsv> => {
  let interval: any;

  return new Promise<ExportCsv>((resolve, reject) => {
    interval = setInterval(
      () =>
        getDiagnosticCsvExport(exportCsv.id)
          .then((updatedExportCsv) => {
            if (updatedExportCsv.url) {
              resolve(updatedExportCsv);
            }

            if (updatedExportCsv.error) {
              reject(updatedExportCsv.error);
            }
          })
          .catch((error) => reject(error)),
      3000
    );
  }).finally(() => clearInterval(interval));
};
